import { render, staticRenderFns } from "./Ultrasounds.vue?vue&type=template&id=616b00be&scoped=true"
import script from "./Ultrasounds.vue?vue&type=script&lang=js"
export * from "./Ultrasounds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616b00be",
  null
  
)

export default component.exports